import { useEffect } from 'react'
import { isPlatformWeb } from '../utilities'

export const useGlobalIonItemFocus = () => {
  useEffect(() => {
    if (isPlatformWeb()) {
      document.documentElement.setAttribute('data-platform', 'web')
    }
  })

  useEffect(() => {
    if (!isPlatformWeb()) return

    const isFocusable = (el: Element): boolean => {
      const tag = el.tagName.toLowerCase()
      if (['input', 'textarea', 'select', 'button', 'a', 'radio', 'ion-toggle'].includes(tag)) return true
      if (tag.startsWith('ion-')) {
        return ['ion-input', 'ion-textarea', 'ion-select', 'ion-button', 'ion-radio', 'ion-toggle'].includes(tag)
      }
      const tabindex = el.getAttribute('tabindex')
      return tabindex === '0'
    }

    const enhanceIonItems = () => {
      const ionItems = document.querySelectorAll(
        'ion-item:not([data-has-click]):not([data-skip-auto-enhance]):not([button="true"])'
      )

      ionItems.forEach((ionItem) => {
        const el = ionItem as HTMLElement

        if (el.hasAttribute('data-has-click')) return
        if (el.getAttribute('disabled') === 'true') return

        const hasFocusableDescendant = el.querySelector('*') && Array.from(el.querySelectorAll('*')).some(isFocusable)

        if (hasFocusableDescendant) {
          ionItem.setAttribute('data-skip-auto-enhance', 'true')
          return
        }

        const hasOnClick = !!el.onclick
        const hasDOMOnClick = el.hasAttribute('onclick')
        const hasRoleButton = el.getAttribute('role') === 'button'
        const isExplicitlyButton = el.hasAttribute('button')

        if (hasOnClick || hasDOMOnClick || hasRoleButton || isExplicitlyButton) {
          el.setAttribute('data-has-click', 'true')
          el.setAttribute('button', 'true')
          el.setAttribute('detail', 'false')
        }
      })
    }

    enhanceIonItems()
    const observer = new MutationObserver(enhanceIonItems)
    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [])
}
